/*
 * Corrige o contador "x / N" dos carrosséis da Home (Lançamentos / Looks).
 *
 * O SliderComponent do Dawn calcula:
 *   slidesPerPage = floor((clientWidth - 1ºItemOffset) / itemOffset)
 *   totalPages    = nº de slides - slidesPerPage + 1
 * Com o "peek" (o próximo card espiando), o floor SUBCONTA quantos cards
 * cabem, então o totalPages fica 1 a mais do que dá pra rolar — o contador
 * mostra "/16" mas o scroll para na página 15.
 *
 * Aqui sobrescrevemos o initPages da INSTÂNCIA pra fixar o totalPages na
 * última página realmente alcançável no fim do scroll. O initPages é
 * re-chamado pelo ResizeObserver do próprio Dawn, então a correção persiste
 * em qualquer resize.
 *
 * Escopado ao contrato explícito .ohli-featured-collection--edge-aligned,
 * configurado pela própria section e preservado no Theme Editor.
 */
(function () {
  function patch(sc) {
    if (!sc || sc.dataset.ohliCounterFix || typeof sc.initPages !== 'function') return;
    sc.dataset.ohliCounterFix = '1';

    var origInitPages = sc.initPages.bind(sc);

    sc.initPages = function () {
      origInitPages();
      if (
        !sc.slider ||
        !sc.sliderItemOffset ||
        !sc.sliderItemsToShow ||
        sc.sliderItemsToShow.length < 2
      ) {
        return;
      }
      // última página alcançável = posição do contador quando o scroll chega
      // ao fim (mesma fórmula que o update() do Dawn usa pro currentPage).
      var reachable =
        Math.round((sc.slider.scrollWidth - sc.slider.clientWidth) / sc.sliderItemOffset) + 1;
      sc.totalPages = Math.max(1, reachable);
      sc.update();
    };

    sc.initPages();
  }

  function init() {
    var sliders = document.querySelectorAll(
      '.ohli-featured-collection--edge-aligned slider-component'
    );
    if (!sliders.length) return;

    var ready =
      window.customElements && customElements.whenDefined
        ? customElements.whenDefined('slider-component')
        : Promise.resolve();

    ready.then(function () {
      sliders.forEach(patch);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', init);
})();
